import React from 'react';
import Header from 'components/Header';
import GalaxyS10 from '../../assets/img/GalaxyS10+.png';
import MurphyCashout from '../../assets/img/mockupsiconsandbadges/Cashout.png';
import HostEvent from '../../assets/img/HOST-YOUR-LIVE-EVENTS-ON-RAVEN-2048x1592.png';
import CryptoPayment from '../../assets/img/Cryptopayments.png';
import Share from '../../assets/img/Share.png';
import Nest from '../../assets/img/mockupsiconsandbadges/Nest.png';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DownloadPlatforms from 'components/DownloadPlatforms';

export default function HomePage() {
  return (
    <main className="home" id="home">
      <section className="top-section">
        <div className="discoLines"></div>

        <Header />

        <div className="hero">
          <div className="">
            <h2>Create, Earn and Connect</h2>
            <p>
              Raven is a live-streaming and social networking app helping
              African creators earn globally
            </p>
            <DownloadPlatforms />
          </div>

          <div className="imgContainer">
            <img src={GalaxyS10} alt="" />
          </div>
        </div>
      </section>

      <section className="section events">
        <h2>Enjoy events from the comfort of your home</h2>
        <p>
          You have access to millions of live events happening worldwide in
          rea-time. Buy tickets and tune in to your favourite events
        </p>
        <div className="cards">
          <div className="card">Concerts</div>
          <div className="card">Parties</div>
          <div className="card">Comedy</div>
          <div className="card">Games</div>
          <div className="card">Talkshows</div>
          <div className="card">Podcasts</div>
          <div className="card">Masterclasses</div>
          <div className="card">Religious</div>
          <div className="card">Fundraisers</div>
          <div className="card">Sports</div>
          <div className="card">Movies</div>
          <div className="card">Music</div>
        </div>
      </section>

      <section className="section how-it-works">
        <div className="intro">
          <h2>
            Welcome to the <span>future of entertainment</span>
          </h2>
          <p>
            You now have he freedom to create events right in the
            moment-instantaneously host live events , add guests artists,
            sonsored ads with the tap of a finger.
          </p>
        </div>

        <div className="grid-layout">
          <div className="imgContainer-1">
            <img src={HostEvent} alt="" />
          </div>
          <div className="grid-text">
            <h2>Not another app - an entirely new approach to entertainment</h2>
            <p>
              Host and Monetize Live Events in Less Time With Fewer Barriers,
              All on Your Mobile Device.
            </p>
            <a
              href="https://www.youtube.com/shorts/Wr4PqNjhqGs"
              className="button"
            >
              <FontAwesomeIcon className="icon" icon={['fab', 'youtube']} />
              See How it Works
            </a>
          </div>
        </div>

        <div className="grid-layout">
          <div className="">
            <h2>Withdraw ticket sales directly to your bank</h2>
            <p>
              Withdraw ticket sales into your bank account, interact with fans
              and build a truly memorable experience for viewers
            </p>
          </div>

          <div className="imgContainer">
            <img src={MurphyCashout} alt="" />
          </div>
        </div>
      </section>

      <section className="section words-of-mouth">
        <div className="intro">
          <h2>We are democratizing content</h2>
          <p>Publishing and distributing on the go just got super easy</p>
          <button>
            Join Now{' '}
            <FontAwesomeIcon className="icon" icon={['fa', 'arrow-right']} />
          </button>
        </div>
      </section>

      <section className="section monetize">
        <div className="grid-layout">
          <div className="imgContainer-1">
            <img src={Share} alt="" />
          </div>{' '}
          <div className="grid-text">
            <h2>Monetize digital products from anywhere, anytime!</h2>
            <p>
              Take advantage of our play marketplace. You automatically get your
              digital publishing store where you can monetize your video and
              audio content like YouTube videos, Anchor/Spotify content, and
              music.
            </p>
            <button>
              Get Started{' '}
              <FontAwesomeIcon className="icon" icon={['fa', 'arrow-right']} />
            </button>
          </div>
        </div>
        <div className="grid-layout">
          <div className="grid-text">
            <h2>Cryptocurrency payments</h2>
            <p>
              Make payments with US Dollars, Naya Token, and Bitcoin no matter
              where you are exclusively on Raven. You can also Tip your friends
              and recieve donations with Bitcoin.
            </p>
            <button>
              Start Earning{' '}
              <FontAwesomeIcon className="icon" icon={['fa', 'arrow-right']} />
            </button>
          </div>
          <div className="imgContainer">
            <img src={CryptoPayment} alt="" />
          </div>
        </div>
      </section>

      <section className="section nest">
        <div className="">
          <div className="imgContainer">
            <img src={Nest} alt="" />
          </div>
          <h2>Join The Nest</h2>
          <p>
            Explore our Nest. A community that truly believes in free and
            democratic speech. Share ideas, meet and interact with cool people
            from all over the world. <br /> Drop a &quot;Twig&quot; today!
          </p>
          <DownloadPlatforms />
        </div>
      </section>
    </main>
  );
}
